export default __webpack_public_path__ + "static/media/nico-uchitel-2.f8da394a.png";